import { useMutation } from '@tanstack/react-query';
import * as service from '../services';
import { useManageComercialTableStore } from '../ManageComercialTable.store';
import { useEffect } from 'react';

export const useComercialTableBigNumbers = () => {
  const { comercialTableItem, setManageComercialTableState } = useManageComercialTableStore();

  const getComercialBigNumbers = async data => {
    const body = {
      id: comercialTableItem?.id,
      descricao: data.descricao || [],
      familia: data.familia || [],
      tier: data.tier || [],
    };
    const resp = await service.getComercialTableBigNumbers(body);
    return resp;
  };

  const successAction = data => {
    setManageComercialTableState('comercialBigNumbersData', data.data);
  };

  const comercialTableBigNumbersMutation = useMutation({
    mutationFn: async (payload: any) => await getComercialBigNumbers(payload),
    onSuccess: data => successAction(data),
  });

  useEffect(() => {
    if (comercialTableItem?.id) {
      comercialTableBigNumbersMutation.mutateAsync({});
    }
  }, [comercialTableItem?.id]);

  return {
    handleGetComercialTableBigNumbers: comercialTableBigNumbersMutation.mutateAsync,
    comercialBigNumbersLoading: comercialTableBigNumbersMutation.isLoading,
  };
};
